/**
 * SEO servis — pretraga i snimanje SEO meta podataka entiteta.
 */
import ApiService from '@/core/api/ApiService';
import { API_ENDPOINTS } from '@/core/api/endpoints';

class SeoService {
  /**
   * Učitava SEO zapis za jedan entitet.
   * @param {string|number} entityId - ID entiteta.
   * @param {AbortSignal|null} [signal] - Opcioni AbortSignal za otkazivanje zahteva.
   * @returns {Promise<object>} SEO podaci entiteta.
   */
  async searchOne(entityId, signal = null) {
    const response = await ApiService.post(
      API_ENDPOINTS.SEO.SEARCH_ONE,
      { entity_id: String(entityId) },
      {},
      signal
    );
    return response.data;
  }

  /**
   * Snima ili ažurira SEO meta podatke entiteta.
   * @param {object} payload - SEO payload za BE.
   * @returns {Promise<object>} Sačuvani SEO zapis.
   */
  async saveOrUpdate(payload) {
    const response = await ApiService.post(API_ENDPOINTS.SEO.SAVE_OR_UPDATE, payload);
    return response.data;
  }
}

const seoServiceInstance = new SeoService();
export default seoServiceInstance;
